export const getInitialState = ({ currentCard, loading, cache }) => {
  return {
    filter: {
      ...currentCard.filter,
      ...(cache && cache.filter)
    },
    limit: (cache && cache.limit) || 10,
    pageNum: (cache && cache.pageNum) || 0,
    pageSize: (cache && cache.limit) || 10,
    order: (cache && cache.order) || {
      id: -1,
      name: "",
      comparator: "",
      sort: ""
    },
    mode: undefined,
    userPageCount: 0,
    showSideBar: false,
    showConfirmationDialog: false,
    deleteId: undefined,
    selectedRealtor: undefined,
    Realtors: [],
    loading: loading,
    render: !loading
  };
};

export default function reducer(state, action) {
  switch (action.type) {
    case "UPDATE":
      return Object.assign({}, state, { ...action.payload });

    case "RESET":
      return Object.assign({}, state, {
        ...action.payload,
        filter: {
          text: ""
        },
        search: "",
        searchTerm: "",
        limit: 10,
        pageSize: 10,
        pageNum: 0,
        order: {
          id: -1,
          name: "",
          comparator: "",
          sort: ""
        },
        userPageCount: 0
      });

    default:
      return state;
  }
}
